import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#54mnsok15__clip0_1_87261)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#xzylhgiuf__clip1_1_87261)",
          children: [_jsx("path", {
            d: "M23.1828 2.84317H-3.18143V17.1569H23.1828V2.84317Z",
            fill: "white"
          }), _jsx("path", {
            d: "M2.483 7.35432L4.55623 4.37672L2.483 7.35432ZM3.26165 7.8508L5.33487 4.87321L3.26165 7.8508ZM4.03894 8.34728L6.11216 5.36969Z",
            fill: "black"
          }), _jsx("path", {
            d: "M4.2975 8.51174L3.77886 8.17989L5.85209 5.2023L6.37073 5.53415L4.2975 8.51174ZM3.52021 8.01526L3.00157 7.68341L5.07479 4.70582L5.59344 5.03767L3.52021 8.01526ZM2.74292 7.51878L2.22427 7.18693L4.2975 4.20934L4.81615 4.54119L2.74292 7.51878Z",
            fill: "black"
          }), _jsx("path", {
            d: "M13.8875 14.6304L15.9607 11.6528L13.8875 14.6304ZM14.6648 15.1269L16.738 12.1493L14.6648 15.1269ZM15.4421 15.6234L17.5153 12.6458Z",
            fill: "black"
          }), _jsx("path", {
            d: "M15.7027 15.7905L15.184 15.4587L17.2572 12.4811L17.7759 12.8129L15.7027 15.7905ZM14.9254 15.2941L14.4067 14.9622L16.48 11.9846L16.9986 12.3165L14.9254 15.2941ZM14.1467 14.7976L13.6281 14.4657L15.7013 11.4881L16.22 11.82L14.1467 14.7976Z",
            fill: "black"
          }), _jsx("path", {
            d: "M14.4063 12.8129L16.9982 14.4656Z",
            fill: "black"
          }), _jsx("path", {
            d: "M14.4938 12.6863L14.321 12.9344L16.9138 14.5889L17.0866 14.3408L14.4938 12.6863Z",
            fill: "white"
          }), _jsx("path", {
            d: "M9.99996 13.5791C12.0649 13.5791 13.7388 11.9767 13.7388 10C13.7388 8.02338 12.0649 6.42097 9.99996 6.42097C7.93505 6.42097 6.26111 8.02338 6.26111 10C6.26111 11.9767 7.93505 13.5791 9.99996 13.5791Z",
            fill: "#CD2E3A"
          }), _jsx("path", {
            d: "M6.88924 8.01535C6.31642 8.8385 6.54799 9.94813 7.40788 10.4965C8.26778 11.0448 9.42694 10.8231 9.99975 9.99998C10.5726 9.17683 11.7317 8.95517 12.5916 9.5035C13.4515 10.0518 13.6831 11.1615 13.1103 11.9846C11.9633 13.6283 9.64361 14.0742 7.92653 12.9776C6.20944 11.8809 5.74361 9.65905 6.88924 8.01535Z",
            fill: "#0047A0"
          }), _jsx("path", {
            d: "M4.55758 15.6234L2.483 12.6458L4.55758 15.6234ZM5.33487 15.1269L3.26165 12.1493L5.33487 15.1269ZM6.11216 14.6304L4.03894 11.6528Z",
            fill: "black"
          }), _jsx("path", {
            d: "M4.2975 15.7905L2.22427 12.8129L2.74292 12.4811L4.81615 15.4587L4.2975 15.7905ZM5.07479 15.2941L3.00157 12.3165L3.52021 11.9846L5.59344 14.9622L5.07479 15.2941ZM5.85344 14.7976L3.77886 11.82L4.2975 11.4881L6.37073 14.4657L5.85344 14.7976Z",
            fill: "black"
          }), _jsx("path", {
            d: "M15.9607 8.34728L13.8875 5.36969L15.9607 8.34728ZM16.738 7.8508L14.6648 4.87321L16.738 7.8508ZM17.5167 7.35432L15.4434 4.37672Z",
            fill: "black"
          }), _jsx("path", {
            d: "M15.7021 8.51174L13.6288 5.53415L14.1475 5.2023L16.2207 8.17989L15.7021 8.51174ZM16.4794 8.01526L14.4061 5.03767L14.9248 4.70582L16.998 7.68341L16.4794 8.01526ZM17.2567 7.51878L15.1834 4.54119L15.7021 4.20934L17.7753 7.18693L17.2567 7.51878Z",
            fill: "black"
          }), _jsx("path", {
            d: "M3.90915 13.8862L4.68644 13.3897L3.90915 13.8862ZM14.4067 7.18697L15.314 6.60753L14.4067 7.18697ZM16.0912 6.11364L16.8685 5.61716Z",
            fill: "black"
          }), _jsx("path", {
            d: "M3.99699 14.0107L3.82501 13.7618L4.6023 13.2653L4.77428 13.5129L3.99699 14.0107ZM14.4931 7.31143L14.3212 7.06383L15.2284 6.48439L15.4004 6.73198L14.4931 7.31143ZM16.1777 6.23809L16.0057 5.9905L16.783 5.49402L16.955 5.74161L16.1777 6.23809Z",
            fill: "white"
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "black"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "54mnsok15__clip0_1_87261",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "xzylhgiuf__clip1_1_87261",
          children: _jsx("rect", {
            width: "26",
            height: "14",
            fill: "white",
            transform: "translate(-3 3)"
          })
        })]
      })]
    }))
  });
};
export default Component;
